import summary from './_data/corpus-summary.json'

export const ultheraEvidenceSources = Object.fromEntries(Object.entries(summary.topics).map(([topic, info]) => [topic, info.sources.map(source => ({ '네이버': 'N', '구글': 'G', '카카오': 'K', '모두닥': 'M' })[source] ?? source)]))

/** 근거 후기 페이지와 시술 본문 CTA가 함께 사용하는 집계 숫자. */
export const ultheraEvidenceCounts = {
  effect: summary.topics.effect.total,
  price: summary.topics.price.total,
  reviews: 214,
  'side-effect': summary.topics['side-effect'].total,
  pain: summary.topics.pain.total,
  recovery: summary.topics.recovery.total,
} as const
